import {
    transformStep,
    shouldTransform,
    onNewLoop,
    shouldMask
} from 'pattern/groups/stepGroups.js';
import {
    PROBABILITY,
    EVERY,
    GATE_MASK} from 'pattern/groups/transformations.js';

export default superclass => class extends superclass  {
    setGroupBits(track, step) {
        let patternStep = track.getPatternStep(step);
        if (patternStep === 0) {
            for (let group of track.stepGroups) {
                onNewLoop(group);
            }
        }
    }

    scheduleAnyStepGroups(track, time) {
        if (track.stepGroups.length > 0) {
            // then we need to transform the pattern
            track.pattern.transform();

            // update the UX to show these transformations only
            // if we are in group mode AND the track is in the current
            // shown sub-sequence
            if (this.state.groups.stepsGroupMode &&
                track.subSequence === this.currentSubSequence) {
                track.updateSteps();
            }
        }
    }

    transformStep(step, time, stepNumber) {
        if (!step.group) {
            return {step, time};
        }

        return transformStep(step, step.group, time, stepNumber);
    }

    isStepMasked(step) {
        let prob = step.probability / 100.0;
        let rand = Math.random();
        if (!step.on || rand > prob) {
            // we skip "off" steps or ones where the
            // probabilistic param. says we should skip it
            return true;
        }

        return shouldMask(step);
    }
}
